export default {
  submitContactFormURL: 'https://kdutnma9m3.execute-api.us-east-1.amazonaws.com/dev/submitContactForm'
}
